import type { SectorId } from '../enums';

export const INDUSTRY_CATALOG_REVISION = 1 as const;

export interface IndustryCatalogArea {
  readonly id: `AREA.IND.${string}`;
  readonly name: string;
  readonly sectorId: SectorId;
  readonly yahooLabel: string;
  readonly retiredIn?: number;
}

/** Generated from the MANIFEST-verified source snapshot, then frozen. */
const INDUSTRY_CATALOG_ROWS: readonly IndustryCatalogArea[] = [
  {
    id: 'AREA.IND.ADVERTISING_AGENCIES',
    name: 'Advertising Agencies',
    sectorId: 'COM',
    yahooLabel: 'Advertising Agencies',
  },
  {
    id: 'AREA.IND.AEROSPACE_DEFENSE',
    name: 'Aerospace & Defense',
    sectorId: 'IND',
    yahooLabel: 'Aerospace & Defense',
  },
  {
    id: 'AREA.IND.AGRICULTURAL_INPUTS',
    name: 'Agricultural Inputs',
    sectorId: 'MAT',
    yahooLabel: 'Agricultural Inputs',
  },
  { id: 'AREA.IND.AIRLINES', name: 'Airlines', sectorId: 'IND', yahooLabel: 'Airlines' },
  {
    id: 'AREA.IND.APPAREL_MANUFACTURING',
    name: 'Apparel Manufacturing',
    sectorId: 'DIS',
    yahooLabel: 'Apparel Manufacturing',
  },
  {
    id: 'AREA.IND.APPAREL_RETAIL',
    name: 'Apparel Retail',
    sectorId: 'DIS',
    yahooLabel: 'Apparel Retail',
  },
  {
    id: 'AREA.IND.ASSET_MANAGEMENT',
    name: 'Asset Management',
    sectorId: 'FIN',
    yahooLabel: 'Asset Management',
  },
  {
    id: 'AREA.IND.AUTO_TRUCK_DEALERSHIPS',
    name: 'Auto & Truck Dealerships',
    sectorId: 'DIS',
    yahooLabel: 'Auto & Truck Dealerships',
  },
  {
    id: 'AREA.IND.AUTO_MANUFACTURERS',
    name: 'Auto Manufacturers',
    sectorId: 'DIS',
    yahooLabel: 'Auto Manufacturers',
  },
  { id: 'AREA.IND.AUTO_PARTS', name: 'Auto Parts', sectorId: 'DIS', yahooLabel: 'Auto Parts' },
  {
    id: 'AREA.IND.BANKS_DIVERSIFIED',
    name: 'Banks - Diversified',
    sectorId: 'FIN',
    yahooLabel: 'Banks - Diversified',
  },
  {
    id: 'AREA.IND.BANKS_REGIONAL',
    name: 'Banks - Regional',
    sectorId: 'FIN',
    yahooLabel: 'Banks - Regional',
  },
  {
    id: 'AREA.IND.BEVERAGES_BREWERS',
    name: 'Beverages - Brewers',
    sectorId: 'STA',
    yahooLabel: 'Beverages - Brewers',
  },
  {
    id: 'AREA.IND.BEVERAGES_NON_ALCOHOLIC',
    name: 'Beverages - Non-Alcoholic',
    sectorId: 'STA',
    yahooLabel: 'Beverages - Non-Alcoholic',
  },
  {
    id: 'AREA.IND.BEVERAGES_WINERIES_DISTILLERIES',
    name: 'Beverages - Wineries & Distilleries',
    sectorId: 'STA',
    yahooLabel: 'Beverages - Wineries & Distilleries',
  },
  {
    id: 'AREA.IND.BIOTECHNOLOGY',
    name: 'Biotechnology',
    sectorId: 'HLT',
    yahooLabel: 'Biotechnology',
  },
  {
    id: 'AREA.IND.BUILDING_MATERIALS',
    name: 'Building Materials',
    sectorId: 'MAT',
    yahooLabel: 'Building Materials',
  },
  {
    id: 'AREA.IND.BUILDING_PRODUCTS_EQUIPMENT',
    name: 'Building Products & Equipment',
    sectorId: 'IND',
    yahooLabel: 'Building Products & Equipment',
  },
  {
    id: 'AREA.IND.CAPITAL_MARKETS',
    name: 'Capital Markets',
    sectorId: 'FIN',
    yahooLabel: 'Capital Markets',
  },
  { id: 'AREA.IND.CHEMICALS', name: 'Chemicals', sectorId: 'MAT', yahooLabel: 'Chemicals' },
  {
    id: 'AREA.IND.COMMUNICATION_EQUIPMENT',
    name: 'Communication Equipment',
    sectorId: 'TEC',
    yahooLabel: 'Communication Equipment',
  },
  {
    id: 'AREA.IND.COMPUTER_HARDWARE',
    name: 'Computer Hardware',
    sectorId: 'TEC',
    yahooLabel: 'Computer Hardware',
  },
  {
    id: 'AREA.IND.CONFECTIONERS',
    name: 'Confectioners',
    sectorId: 'STA',
    yahooLabel: 'Confectioners',
  },
  {
    id: 'AREA.IND.CONGLOMERATES',
    name: 'Conglomerates',
    sectorId: 'IND',
    yahooLabel: 'Conglomerates',
  },
  {
    id: 'AREA.IND.CONSULTING_SERVICES',
    name: 'Consulting Services',
    sectorId: 'IND',
    yahooLabel: 'Consulting Services',
  },
  {
    id: 'AREA.IND.CONSUMER_ELECTRONICS',
    name: 'Consumer Electronics',
    sectorId: 'TEC',
    yahooLabel: 'Consumer Electronics',
  },
  { id: 'AREA.IND.COPPER', name: 'Copper', sectorId: 'MAT', yahooLabel: 'Copper' },
  {
    id: 'AREA.IND.CREDIT_SERVICES',
    name: 'Credit Services',
    sectorId: 'FIN',
    yahooLabel: 'Credit Services',
  },
  {
    id: 'AREA.IND.DIAGNOSTICS_RESEARCH',
    name: 'Diagnostics & Research',
    sectorId: 'HLT',
    yahooLabel: 'Diagnostics & Research',
  },
  {
    id: 'AREA.IND.DISCOUNT_STORES',
    name: 'Discount Stores',
    sectorId: 'STA',
    yahooLabel: 'Discount Stores',
  },
  {
    id: 'AREA.IND.DRUG_MANUFACTURERS_GENERAL',
    name: 'Drug Manufacturers - General',
    sectorId: 'HLT',
    yahooLabel: 'Drug Manufacturers - General',
  },
  {
    id: 'AREA.IND.DRUG_MANUFACTURERS_SPECIALTY_GENERIC',
    name: 'Drug Manufacturers - Specialty & Generic',
    sectorId: 'HLT',
    yahooLabel: 'Drug Manufacturers - Specialty & Generic',
  },
  {
    id: 'AREA.IND.ELECTRICAL_EQUIPMENT_PARTS',
    name: 'Electrical Equipment & Parts',
    sectorId: 'IND',
    yahooLabel: 'Electrical Equipment & Parts',
  },
  {
    id: 'AREA.IND.ELECTRONIC_COMPONENTS',
    name: 'Electronic Components',
    sectorId: 'TEC',
    yahooLabel: 'Electronic Components',
  },
  {
    id: 'AREA.IND.ELECTRONIC_GAMING_MULTIMEDIA',
    name: 'Electronic Gaming & Multimedia',
    sectorId: 'COM',
    yahooLabel: 'Electronic Gaming & Multimedia',
  },
  {
    id: 'AREA.IND.ENGINEERING_CONSTRUCTION',
    name: 'Engineering & Construction',
    sectorId: 'IND',
    yahooLabel: 'Engineering & Construction',
  },
  {
    id: 'AREA.IND.ENTERTAINMENT',
    name: 'Entertainment',
    sectorId: 'COM',
    yahooLabel: 'Entertainment',
  },
  {
    id: 'AREA.IND.FARM_HEAVY_CONSTRUCTION_MACHINERY',
    name: 'Farm & Heavy Construction Machinery',
    sectorId: 'IND',
    yahooLabel: 'Farm & Heavy Construction Machinery',
  },
  {
    id: 'AREA.IND.FARM_PRODUCTS',
    name: 'Farm Products',
    sectorId: 'STA',
    yahooLabel: 'Farm Products',
  },
  {
    id: 'AREA.IND.FINANCIAL_DATA_STOCK_EXCHANGES',
    name: 'Financial Data & Stock Exchanges',
    sectorId: 'FIN',
    yahooLabel: 'Financial Data & Stock Exchanges',
  },
  {
    id: 'AREA.IND.FOOD_DISTRIBUTION',
    name: 'Food Distribution',
    sectorId: 'STA',
    yahooLabel: 'Food Distribution',
  },
  {
    id: 'AREA.IND.FOOTWEAR_ACCESSORIES',
    name: 'Footwear & Accessories',
    sectorId: 'DIS',
    yahooLabel: 'Footwear & Accessories',
  },
  { id: 'AREA.IND.GOLD', name: 'Gold', sectorId: 'MAT', yahooLabel: 'Gold' },
  {
    id: 'AREA.IND.GROCERY_STORES',
    name: 'Grocery Stores',
    sectorId: 'STA',
    yahooLabel: 'Grocery Stores',
  },
  {
    id: 'AREA.IND.HEALTH_INFORMATION_SERVICES',
    name: 'Health Information Services',
    sectorId: 'HLT',
    yahooLabel: 'Health Information Services',
  },
  {
    id: 'AREA.IND.HEALTHCARE_PLANS',
    name: 'Healthcare Plans',
    sectorId: 'HLT',
    yahooLabel: 'Healthcare Plans',
  },
  {
    id: 'AREA.IND.HOME_IMPROVEMENT_RETAIL',
    name: 'Home Improvement Retail',
    sectorId: 'DIS',
    yahooLabel: 'Home Improvement Retail',
  },
  {
    id: 'AREA.IND.HOUSEHOLD_PERSONAL_PRODUCTS',
    name: 'Household & Personal Products',
    sectorId: 'STA',
    yahooLabel: 'Household & Personal Products',
  },
  {
    id: 'AREA.IND.INDUSTRIAL_DISTRIBUTION',
    name: 'Industrial Distribution',
    sectorId: 'IND',
    yahooLabel: 'Industrial Distribution',
  },
  {
    id: 'AREA.IND.INFORMATION_TECHNOLOGY_SERVICES',
    name: 'Information Technology Services',
    sectorId: 'TEC',
    yahooLabel: 'Information Technology Services',
  },
  {
    id: 'AREA.IND.INSURANCE_DIVERSIFIED',
    name: 'Insurance - Diversified',
    sectorId: 'FIN',
    yahooLabel: 'Insurance - Diversified',
  },
  {
    id: 'AREA.IND.INSURANCE_LIFE',
    name: 'Insurance - Life',
    sectorId: 'FIN',
    yahooLabel: 'Insurance - Life',
  },
  {
    id: 'AREA.IND.INSURANCE_PROPERTY_CASUALTY',
    name: 'Insurance - Property & Casualty',
    sectorId: 'FIN',
    yahooLabel: 'Insurance - Property & Casualty',
  },
  {
    id: 'AREA.IND.INSURANCE_REINSURANCE',
    name: 'Insurance - Reinsurance',
    sectorId: 'FIN',
    yahooLabel: 'Insurance - Reinsurance',
  },
  {
    id: 'AREA.IND.INSURANCE_BROKERS',
    name: 'Insurance Brokers',
    sectorId: 'FIN',
    yahooLabel: 'Insurance Brokers',
  },
  {
    id: 'AREA.IND.INTEGRATED_FREIGHT_LOGISTICS',
    name: 'Integrated Freight & Logistics',
    sectorId: 'IND',
    yahooLabel: 'Integrated Freight & Logistics',
  },
  {
    id: 'AREA.IND.INTERNET_CONTENT_INFORMATION',
    name: 'Internet Content & Information',
    sectorId: 'COM',
    yahooLabel: 'Internet Content & Information',
  },
  {
    id: 'AREA.IND.INTERNET_RETAIL',
    name: 'Internet Retail',
    sectorId: 'DIS',
    yahooLabel: 'Internet Retail',
  },
  { id: 'AREA.IND.LEISURE', name: 'Leisure', sectorId: 'DIS', yahooLabel: 'Leisure' },
  { id: 'AREA.IND.LODGING', name: 'Lodging', sectorId: 'DIS', yahooLabel: 'Lodging' },
  {
    id: 'AREA.IND.LUXURY_GOODS',
    name: 'Luxury Goods',
    sectorId: 'DIS',
    yahooLabel: 'Luxury Goods',
  },
  {
    id: 'AREA.IND.MEDICAL_CARE_FACILITIES',
    name: 'Medical Care Facilities',
    sectorId: 'HLT',
    yahooLabel: 'Medical Care Facilities',
  },
  {
    id: 'AREA.IND.MEDICAL_DEVICES',
    name: 'Medical Devices',
    sectorId: 'HLT',
    yahooLabel: 'Medical Devices',
  },
  {
    id: 'AREA.IND.MEDICAL_DISTRIBUTION',
    name: 'Medical Distribution',
    sectorId: 'HLT',
    yahooLabel: 'Medical Distribution',
  },
  {
    id: 'AREA.IND.MEDICAL_INSTRUMENTS_SUPPLIES',
    name: 'Medical Instruments & Supplies',
    sectorId: 'HLT',
    yahooLabel: 'Medical Instruments & Supplies',
  },
  {
    id: 'AREA.IND.OIL_GAS_E_P',
    name: 'Oil & Gas E&P',
    sectorId: 'ENE',
    yahooLabel: 'Oil & Gas E&P',
  },
  {
    id: 'AREA.IND.OIL_GAS_EQUIPMENT_SERVICES',
    name: 'Oil & Gas Equipment & Services',
    sectorId: 'ENE',
    yahooLabel: 'Oil & Gas Equipment & Services',
  },
  {
    id: 'AREA.IND.OIL_GAS_INTEGRATED',
    name: 'Oil & Gas Integrated',
    sectorId: 'ENE',
    yahooLabel: 'Oil & Gas Integrated',
  },
  {
    id: 'AREA.IND.OIL_GAS_MIDSTREAM',
    name: 'Oil & Gas Midstream',
    sectorId: 'ENE',
    yahooLabel: 'Oil & Gas Midstream',
  },
  {
    id: 'AREA.IND.OIL_GAS_REFINING_MARKETING',
    name: 'Oil & Gas Refining & Marketing',
    sectorId: 'ENE',
    yahooLabel: 'Oil & Gas Refining & Marketing',
  },
  {
    id: 'AREA.IND.PACKAGED_FOODS',
    name: 'Packaged Foods',
    sectorId: 'STA',
    yahooLabel: 'Packaged Foods',
  },
  {
    id: 'AREA.IND.PACKAGING_CONTAINERS',
    name: 'Packaging & Containers',
    sectorId: 'DIS',
    yahooLabel: 'Packaging & Containers',
  },
  {
    id: 'AREA.IND.PERSONAL_SERVICES',
    name: 'Personal Services',
    sectorId: 'DIS',
    yahooLabel: 'Personal Services',
  },
  {
    id: 'AREA.IND.POLLUTION_TREATMENT_CONTROLS',
    name: 'Pollution & Treatment Controls',
    sectorId: 'IND',
    yahooLabel: 'Pollution & Treatment Controls',
  },
  {
    id: 'AREA.IND.REIT_DIVERSIFIED',
    name: 'REIT - Diversified',
    sectorId: 'REI',
    yahooLabel: 'REIT - Diversified',
  },
  {
    id: 'AREA.IND.REIT_HEALTHCARE_FACILITIES',
    name: 'REIT - Healthcare Facilities',
    sectorId: 'REI',
    yahooLabel: 'REIT - Healthcare Facilities',
  },
  {
    id: 'AREA.IND.REIT_HOTEL_MOTEL',
    name: 'REIT - Hotel & Motel',
    sectorId: 'REI',
    yahooLabel: 'REIT - Hotel & Motel',
  },
  {
    id: 'AREA.IND.REIT_INDUSTRIAL',
    name: 'REIT - Industrial',
    sectorId: 'REI',
    yahooLabel: 'REIT - Industrial',
  },
  {
    id: 'AREA.IND.REIT_OFFICE',
    name: 'REIT - Office',
    sectorId: 'REI',
    yahooLabel: 'REIT - Office',
  },
  {
    id: 'AREA.IND.REIT_RESIDENTIAL',
    name: 'REIT - Residential',
    sectorId: 'REI',
    yahooLabel: 'REIT - Residential',
  },
  {
    id: 'AREA.IND.REIT_RETAIL',
    name: 'REIT - Retail',
    sectorId: 'REI',
    yahooLabel: 'REIT - Retail',
  },
  {
    id: 'AREA.IND.REIT_SPECIALTY',
    name: 'REIT - Specialty',
    sectorId: 'REI',
    yahooLabel: 'REIT - Specialty',
  },
  { id: 'AREA.IND.RAILROADS', name: 'Railroads', sectorId: 'IND', yahooLabel: 'Railroads' },
  {
    id: 'AREA.IND.REAL_ESTATE_SERVICES',
    name: 'Real Estate Services',
    sectorId: 'REI',
    yahooLabel: 'Real Estate Services',
  },
  {
    id: 'AREA.IND.RENTAL_LEASING_SERVICES',
    name: 'Rental & Leasing Services',
    sectorId: 'IND',
    yahooLabel: 'Rental & Leasing Services',
  },
  {
    id: 'AREA.IND.RESIDENTIAL_CONSTRUCTION',
    name: 'Residential Construction',
    sectorId: 'DIS',
    yahooLabel: 'Residential Construction',
  },
  {
    id: 'AREA.IND.RESORTS_CASINOS',
    name: 'Resorts & Casinos',
    sectorId: 'DIS',
    yahooLabel: 'Resorts & Casinos',
  },
  { id: 'AREA.IND.RESTAURANTS', name: 'Restaurants', sectorId: 'DIS', yahooLabel: 'Restaurants' },
  {
    id: 'AREA.IND.SCIENTIFIC_TECHNICAL_INSTRUMENTS',
    name: 'Scientific & Technical Instruments',
    sectorId: 'TEC',
    yahooLabel: 'Scientific & Technical Instruments',
  },
  {
    id: 'AREA.IND.SECURITY_PROTECTION_SERVICES',
    name: 'Security & Protection Services',
    sectorId: 'IND',
    yahooLabel: 'Security & Protection Services',
  },
  {
    id: 'AREA.IND.SEMICONDUCTOR_EQUIPMENT_MATERIALS',
    name: 'Semiconductor Equipment & Materials',
    sectorId: 'TEC',
    yahooLabel: 'Semiconductor Equipment & Materials',
  },
  {
    id: 'AREA.IND.SEMICONDUCTORS',
    name: 'Semiconductors',
    sectorId: 'TEC',
    yahooLabel: 'Semiconductors',
  },
  {
    id: 'AREA.IND.SOFTWARE_APPLICATION',
    name: 'Software - Application',
    sectorId: 'TEC',
    yahooLabel: 'Software - Application',
  },
  {
    id: 'AREA.IND.SOFTWARE_INFRASTRUCTURE',
    name: 'Software - Infrastructure',
    sectorId: 'TEC',
    yahooLabel: 'Software - Infrastructure',
  },
  { id: 'AREA.IND.SOLAR', name: 'Solar', sectorId: 'TEC', yahooLabel: 'Solar' },
  {
    id: 'AREA.IND.SPECIALTY_BUSINESS_SERVICES',
    name: 'Specialty Business Services',
    sectorId: 'IND',
    yahooLabel: 'Specialty Business Services',
  },
  {
    id: 'AREA.IND.SPECIALTY_CHEMICALS',
    name: 'Specialty Chemicals',
    sectorId: 'MAT',
    yahooLabel: 'Specialty Chemicals',
  },
  {
    id: 'AREA.IND.SPECIALTY_INDUSTRIAL_MACHINERY',
    name: 'Specialty Industrial Machinery',
    sectorId: 'IND',
    yahooLabel: 'Specialty Industrial Machinery',
  },
  {
    id: 'AREA.IND.SPECIALTY_RETAIL',
    name: 'Specialty Retail',
    sectorId: 'DIS',
    yahooLabel: 'Specialty Retail',
  },
  { id: 'AREA.IND.STEEL', name: 'Steel', sectorId: 'MAT', yahooLabel: 'Steel' },
  {
    id: 'AREA.IND.TELECOM_SERVICES',
    name: 'Telecom Services',
    sectorId: 'COM',
    yahooLabel: 'Telecom Services',
  },
  { id: 'AREA.IND.TOBACCO', name: 'Tobacco', sectorId: 'STA', yahooLabel: 'Tobacco' },
  {
    id: 'AREA.IND.TOOLS_ACCESSORIES',
    name: 'Tools & Accessories',
    sectorId: 'IND',
    yahooLabel: 'Tools & Accessories',
  },
  {
    id: 'AREA.IND.TRAVEL_SERVICES',
    name: 'Travel Services',
    sectorId: 'DIS',
    yahooLabel: 'Travel Services',
  },
  { id: 'AREA.IND.TRUCKING', name: 'Trucking', sectorId: 'IND', yahooLabel: 'Trucking' },
  {
    id: 'AREA.IND.UTILITIES_DIVERSIFIED',
    name: 'Utilities - Diversified',
    sectorId: 'UTL',
    yahooLabel: 'Utilities - Diversified',
  },
  {
    id: 'AREA.IND.UTILITIES_INDEPENDENT_POWER_PRODUCERS',
    name: 'Utilities - Independent Power Producers',
    sectorId: 'UTL',
    yahooLabel: 'Utilities - Independent Power Producers',
  },
  {
    id: 'AREA.IND.UTILITIES_REGULATED_ELECTRIC',
    name: 'Utilities - Regulated Electric',
    sectorId: 'UTL',
    yahooLabel: 'Utilities - Regulated Electric',
  },
  {
    id: 'AREA.IND.UTILITIES_REGULATED_GAS',
    name: 'Utilities - Regulated Gas',
    sectorId: 'UTL',
    yahooLabel: 'Utilities - Regulated Gas',
  },
  {
    id: 'AREA.IND.UTILITIES_REGULATED_WATER',
    name: 'Utilities - Regulated Water',
    sectorId: 'UTL',
    yahooLabel: 'Utilities - Regulated Water',
  },
  {
    id: 'AREA.IND.WASTE_MANAGEMENT',
    name: 'Waste Management',
    sectorId: 'IND',
    yahooLabel: 'Waste Management',
  },
];

export const INDUSTRY_CATALOG: readonly IndustryCatalogArea[] = Object.freeze(
  INDUSTRY_CATALOG_ROWS.map((area) => Object.freeze(area)),
);
